import { ApiInviteEmailType } from "@/types/workflows/workflow.action-notification.types.ts";

interface EmployeeInviteData {
  email?: string;
  email_personal?: string;
  datetime_last_online?: Date;
}

export const getEmployeeInviteEmailTypes = ({ email, email_personal }: EmployeeInviteData) => [
  ...(email ? [ApiInviteEmailType.work] : []),
  ...(email_personal ? [ApiInviteEmailType.personal] : []),
];

export const canSendEmployeeInvite = (employee: EmployeeInviteData, hasPermission: boolean) =>
  hasPermission && getEmployeeInviteEmailTypes(employee).length > 0;

export const canCreateEmployeeInviteLink = (employee: EmployeeInviteData, hasPermission: boolean) =>
  hasPermission &&
  getEmployeeInviteEmailTypes(employee).length > 0 &&
  !employee.datetime_last_online;

export const getEmployeeInviteEmail = (
  employee: EmployeeInviteData,
  inviteEmailType: ApiInviteEmailType
) => (inviteEmailType === ApiInviteEmailType.work ? employee.email : employee.email_personal);
